import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore('personalizations', storeModule.createStoreModule('personalizations'))
